import { EventAttended } from './eventAttended/index.js'
import { EventCreatedByEcpay } from './eventCreatedByEcpay/index.js'
import { EventCreated } from './eventCreated/index.js'
import * as render from './render.pug'
import { useNotificationStore } from '../../store.js'
export const NotificationListItem = {
  ...render,
  props: {
    notification: {
      type: Object
    }
  },
  emits: [],
  components: {
    EventAttended,
    EventCreated,
    EventCreatedByEcpay
  },
  directives: {},
  setup (props, { emit }) {
    const {
      read
    } = useNotificationStore()
    return {
      read
    }
  }
}
